import { t } from 'ttag'
import React from 'react'

const MobileLmi = ({ profile }) => {
  const toCurrency = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3)
  }
  const outlookElement = (ol, v, fmt) => {
    if (ol && ol.hasOwnProperty(v)) {
      if (fmt) {
        return ol[v].toLocaleString()
      }

      return ol[v]
    }

    return fmt ? 'n/a' : null
  }
  const getValues = ele => {
    const myArray = []
    const a10 = outlookElement(ele, 'annual10', false)

    if (a10) {
      myArray.push(a10)
    }

    const a90 = outlookElement(ele, 'annual90', false)
    const aMean = outlookElement(ele, 'annualMean', false)

    if (a90) {
      myArray.push(a90)
    } else if (aMean) {
      myArray.push(aMean)
    }

    return myArray.length > 0 ? myArray : null
  }
  const getOutlookValues = ele => {
    const myArray = []
    const a10 = outlookElement(ele, 'baseEmployment', false)

    if (a10) {
      myArray.push(a10)
    }

    const a90 = outlookElement(ele, 'projectedEmployment', false)

    if (a90) {
      myArray.push(a90)
    }

    return myArray.length > 0 ? myArray : null
  }
  const outlookClass = ele => {
    const projP = outlookElement(ele, 'projectedEmployment')
    const baseP = outlookElement(ele, 'baseEmployment')

    return projP - baseP > 0
      ? 'outlook-increasing'
      : projP - baseP < 0
      ? 'outlook-decreasing'
      : ''
  }
  const initialLmiBox = ele => {
    const wageText = () => {
      const v2 = getValues(profile.wages)

      if (v2) {
        const minCurr = v2.length >= 1 ? toCurrency(v2[0]) : 'n/a'
        let maxCurr = v2.length >= 2 ? toCurrency(v2[1]) : 'n/a'
        const avg = toCurrency(outlookElement(profile.wages, 'annualMean', false))
        const yr = outlookElement(profile.wages, 'year', false)

        if (avg === maxCurr) {
          maxCurr += '+'
        }

        return t`In ${yr}, the average annual wage in ${profile.wages.region} was ${avg} with most workers making between ${minCurr} and ${maxCurr}`
      }

      return null
    }
    const outlookText = () => {
      const v2 = getValues()
      const annualTotal = outlookElement(profile.outlook, 'annualTotal', true)
      const annualTurnover = outlookElement(profile.outlook, 'annualTurnover', true)
      const annualOpenings = outlookElement(profile.outlook, 'annualOpenings', true)
      const projectedEmploymentYear = outlookElement(
        profile.outlook,
        'projectedEmploymentYear',
        false
      )
      const projectedEmployment = outlookElement(
        profile.outlook,
        'projectedEmployment',
        true
      )
      const currentEmployment = outlookElement(profile.outlook, 'baseEmployment', true)
      const yr = outlookElement(profile.outlook, 'baseEmploymentYear', false)

      if (profile.outlook) {
        return (
          <div>
            <p>{t`During ${yr}, occupation employed approximately ${currentEmployment} people in ${profile.outlook.region}. It is projected that there will be ${projectedEmployment} employed in ${projectedEmploymentYear}.`}</p>
            <p>{t`This occupation will have about ${annualOpenings} openings due to growth and about ${annualTurnover} replacement openings for approximately ${annualTotal} total annual openings.`}</p>
          </div>
        )
      }

      return null
    }

    return (
      <div>
        <div>
          <h4>{t`Annual Wage`}</h4>
          <p>{wageText()}</p>
        </div>

        <div>
          <div className={outlookClass(profile.outlook)}>
            <h4 className="clear">{t`Annual Openings`}</h4>
            <p>{outlookText()}</p>
          </div>
          <div>
            <h4 className="clear">{t`Education`}</h4>
            <p>{profile.jobZone ? profile.jobZone.name : t`Not specified`}</p>
            <p>{profile.jobZone ? profile.jobZone.education : ''}</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="visible-xs section">
      <h3 className="title">
        <span>{t`Employment and Wages`}</span>
      </h3>
      {initialLmiBox()}
    </div>
  )
}

export default MobileLmi
